import { render, staticRenderFns } from "./none_role_home.vue?vue&type=template&id=5df9876b&"
import script from "./none_role_home.vue?vue&type=script&lang=js&"
export * from "./none_role_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports